import { doc, getDoc, setDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../firebase';

const memoryCache = new Map();

function cacheKey(userId, dayId) {
  return `${userId}:${dayId}`;
}

function lectureRef(userId, dayId) {
  return doc(db, 'userLectureCache', userId, 'lectures', dayId);
}

export async function loadLectureCache(userId, dayId) {
  if (!userId || !dayId) return null;
  const mem = memoryCache.get(cacheKey(userId, dayId));
  if (mem?.content) return mem;
  const snap = await getDoc(lectureRef(userId, dayId));
  if (!snap.exists()) return null;
  const data = snap.data() || {};
  const cached = {
    content: data.content || '',
    chatMessages: Array.isArray(data.chatMessages) ? data.chatMessages : [],
    generatedAt: data.generatedAt || null,
  };
  if (cached.content) memoryCache.set(cacheKey(userId, dayId), cached);
  return cached;
}

export async function saveLectureContent(userId, dayId, content, meta = {}) {
  if (!userId || !dayId || !content) return;
  const prev = memoryCache.get(cacheKey(userId, dayId)) || {};
  memoryCache.set(cacheKey(userId, dayId), { ...prev, content, chatMessages: prev.chatMessages || [] });
  await setDoc(
    lectureRef(userId, dayId),
    {
      content,
      moduleId: meta.moduleId || '',
      subject: meta.subject || '',
      title: meta.title || '',
      generatedAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
}

export function clearLectureMemoryCache(userId, dayId) {
  if (!userId || !dayId) return;
  memoryCache.delete(cacheKey(userId, dayId));
}

export async function saveLectureChat(userId, dayId, chatMessages) {
  if (!userId || !dayId) return;
  const trimmed = (Array.isArray(chatMessages) ? chatMessages : [])
    .filter((m) => m?.role && m?.content)
    .slice(-40)
    .map((m) => ({ role: m.role, content: String(m.content).slice(0, 8000) }));
  const prev = memoryCache.get(cacheKey(userId, dayId)) || {};
  memoryCache.set(cacheKey(userId, dayId), { ...prev, content: prev.content || '', chatMessages: trimmed });
  await setDoc(
    lectureRef(userId, dayId),
    { chatMessages: trimmed, chatUpdatedAt: serverTimestamp() },
    { merge: true }
  );
}
